export const ARROW_VISIBLE_BP = {
  1200: 4,
  1440: 5,
  1920: 6,
  default: 4,
};
export const SLIDES_TO_SCROLL_BP = {
  1200: 4,
  1440: 4,
  1920: 3,
  default: 3,
};

export const calculateBreakPointByWidth = ([innerWidth]) => {
  if (innerWidth < 1440) return 1200;
  if (innerWidth < 1920) return 1440;
  if (innerWidth >= 1920) return 1920;
  return 'default';
};
